import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ElementRef,
  ViewChild,
  EventEmitter,
  Output,
} from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Onboarding, getStepNumber, Status } from '../../models/onboarding';

@Component({
  selector: 'alg-step',
  templateUrl: './alg-step.component.html',
  styleUrls: ['./alg-step.component.scss'],
})
export class AlgStepComponent implements OnInit, OnChanges {
  @Input() steps: any;
  @Input() containerStepStatus: string;
  public status: string = 'disable';
  public step: any;
  @Output() checkChangeStep: EventEmitter<string> = new EventEmitter();

  constructor(private api: ApiService, private element: ElementRef) {}

  private setStatus(step) {
    this.step = this.steps.find((i) => i.name === step);
    this.status = step;
    setTimeout(() => {
      window.scroll({
        top: 0,
        behavior: 'smooth',
      });
    }, 50);
  }

  ngOnInit() {
    this.api.currentStep.subscribe((webStatus: Status) => {
      this.setStatus(webStatus);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setStatus(this.containerStepStatus);
    if (changes.step) {
      this.setStatus(changes.step.currentValue);
    }
  }

  changeStatus(value) {
    this.setStatus(value);
    return this.checkChangeStep.emit(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-step/alg-step.component.ts